<template>
  <div class="flex items-center">
    <img
      style="width: 25px; height: 25px; object-fit: cover;" 
      class="person-img rounded-full shadow-md block" 
      :src="params.data.file ? params.data.file.file_path : params.data.class_default_image" 
    />
    <router-link 
      :to="{ path: `/pages/classes/details/${params.data.class_id}`, query: {is_archived: params.colDef.CellRendererParams.currentTab() === 0 ? false : true}}"
    >
     {{ params.data.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NameCell'
}
</script>